export default {
    buyBack: 'Buy Out',
    refinance: 'Refinance',
    renewal: '@.capitalize:lexicon.renewed.infinitive',
    refuseToRenew: 'Refuse to @:lexicon.renewed.infinitive',
    return: 'Return',
};
